export const QUOTE_ADD_ITEM = 'QUOTE_ADD_ITEM';
export const QUOTE_REMOVE_ITEM = 'QUOTE_REMOVE_ITEM';
export const QUOTE_LOGIN_ITEM ='QUOTE_LOGIN_ITEM';
export const QUOTE_REMOVE_ALL='QUOTE_REMOVE_ALL';

